"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateIntermediateFields = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const validateIntermediateFields = (params) => {
    const { intermediateFields, queryResultVariables } = params;
    const errors = [];
    const variableSet = new Set();
    queryResultVariables.forEach((queryResultVariable) => {
        if (variableSet.has(queryResultVariable)) {
            errors.push(`Duplicate query result variable: ${queryResultVariable}`);
        }
        else {
            variableSet.add(queryResultVariable);
        }
    });
    const intermediateFieldSet = new Set();
    for (const { config, field } of intermediateFields) {
        const { formula } = config;
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(formula, variableSet);
        formulaErrors.errorMessages.forEach((errorMessage) => {
            errors.push(`Error in intermediate field: ${field}. Error: ${errorMessage}`);
        });
        if (field === '') {
            errors.push('Intermediate field name is empty.');
        }
        if (variableSet.has(field)) {
            errors.push(`Duplicate intermediate field / query variable name: ${field}`);
        }
        else {
            variableSet.add(field);
            intermediateFieldSet.add(field);
        }
        if (field ===
            finley_types_1.FinancialCovenant.RequiredFinancialCovenantField
                .FinancialCovenantReportingDate) {
            const { variables } = (0, formula_engine_1.inspectDependencies)(formula);
            // "financialCovenantReportingDate" formula is limited to only
            // depending upon triggerDate as a variable at the moment,
            // depending on nothing is also acceptable (though unlikely to be the case)
            if (variables.size > 1 ||
                (variables.size === 1 && Array.from(variables)[0] !== 'triggerDate')) {
                errors.push(`${finley_types_1.FinancialCovenant.RequiredFinancialCovenantField
                    .FinancialCovenantReportingDate} can only depend on triggerDate variable, but it depends on [variables:${Array.from(variables)}]`);
            }
        }
    }
    for (const requiredField of finley_types_1.CreditAgreement.Config.FinancialCovenant
        .RequiredIntermediateFieldIterable) {
        if (!intermediateFieldSet.has(requiredField)) {
            errors.push(`Intermediate fields are missing required field ${requiredField}`);
        }
    }
    return { errors };
};
exports.validateIntermediateFields = validateIntermediateFields;
//# sourceMappingURL=intermediateField.js.map